import api from "../../http";

export default class ApiSolutionsCasinoSecondSectionSecurity {
    static async getApiSolutionsCasinoSecondSectionSecurity(url) {
        return api.get(url)
    }
}